import { useState, useMemo } from 'react';
import { format, startOfMonth, endOfMonth, isValid } from 'date-fns';
import useMealDates from './useMealDates';

/**
 * Provides meal date data for a given visible month.
 */
const useMealDatesForMonth = (initialDate, mealType) => {
    const parsedDate = isValid(new Date(initialDate)) ? new Date(initialDate) : new Date();

    const [visibleMonth, setVisibleMonth] = useState(parsedDate);

    const from = useMemo(() => format(startOfMonth(visibleMonth), 'yyyy-MM-dd'), [visibleMonth]);
    const to = useMemo(() => format(endOfMonth(visibleMonth), 'yyyy-MM-dd'), [visibleMonth]);

    const { data, isLoading, isError, error } = useMealDates(from, to, mealType);

    return {
        mealDates: data ?? [],
        isLoading,
        isError,
        error,
        visibleMonth,
        setVisibleMonth
    };
};

export default useMealDatesForMonth;
